import { useEffect, useState } from "react";
import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { MotifCheckbox } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";

export const CreditorColumnDefs = ({
  creditorId,
  setCreditorId,
  setIsPreviewScheme,
  caseData,
}: {
  creditorId: string;
  setCreditorId: (value: string) => void;
  setIsPreviewScheme: (value: boolean) => void;
  caseData: any;
}) => {
  const { t } = useTranslation();
  const CustomHeader = () => {
    const { defaultUnit } = caseData;
    const [unitName, setUnitName] = useState(defaultUnit?.name);

    useEffect(() => {
      setUnitName(defaultUnit?.name);
    }, [defaultUnit]);

    return `(${unitName})`;
  };

  const amountCellRenderer = (field: string) => (params: any) => {
    const { defaultUnit } = caseData;
    const decimalPlace = defaultUnit?.decimalPlace;
    const amount = params.data[field];
    const formattedDefaultAmount = formatAmountUnitDecimalPlace(amount, decimalPlace);
    return formattedDefaultAmount !== "-" ? `${formattedDefaultAmount} ${defaultUnit?.name}`: formattedDefaultAmount;
  };
  return [
    {
      field: "creditorName",
      headerName: t("pages.configuration.scheme.previewColumns.column1"),
      type: "creditorNameType",
      flex: 2,
      minWidth: 150,

      sortable: true,
      unSortIcon: true,

      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      cellRenderer: function (params: any) {
        return (
          <>
            <MotifCheckbox
              checked={params.data.creditorId === creditorId}
              onChange={(event: any) => {
                if (event.target.checked) {
                  setCreditorId(params.data.creditorId);
                  setIsPreviewScheme(true);
                } else {
                  setCreditorId("");
                  setIsPreviewScheme(false);
                }
              }}
              value={params.data.creditorId}
            >
              {params.data.creditorName}
            </MotifCheckbox>
          </>
        );
      },
    },
    {
      cellRenderer: "totalClaimsCellRenderers",
      field: "totalClaims",
      type: "totalClaimsType",
      headerName: t("pages.configuration.scheme.previewColumns.column2"),
      flex: 1,
      minWidth: 150,

      sortable: true,
      unSortIcon: true,

      headerClass: "stepHeaderClass",
      cellClass: "align-right",
    },
    {
      cellRenderer: amountCellRenderer("originalAmount"),
      field: "originalAmount",
      flex: 1,
      minWidth: 150,
      type: "originalAmountType",
      sortable: true,
      unSortIcon: true,

      headerName: t("pages.configuration.scheme.previewColumns.column3", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Original Amount" },
      headerHeight: 200,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: amountCellRenderer("claimAmount"),
      field: "claimAmount",
      type: "claimAmountType",
      headerName: t("pages.configuration.scheme.previewColumns.column4", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Claim Amount" },
      headerHeight: 150,
      flex: 1,
      minWidth: 200,

      sortable: true,
      unSortIcon: true,

      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: amountCellRenderer("latestCreditorPositionAmount"),
      field: "latestCreditorPositionAmount",
      type: "latestCreditorPositionAmountType",
      headerName: t("pages.configuration.scheme.previewColumns.column5", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Latest Creditor Position Amount" },
      headerHeight: 150,
      flex: 1,
      minWidth: 200,

      sortable: true,
      unSortIcon: true,

      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: amountCellRenderer("latestDebtorPositionAmount"),
      field: "latestDebtorPositionAmount",
      type: "latestDebtorPositionAmountType",
      headerName: t("pages.configuration.scheme.previewColumns.column6", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Latest Debtor Position Amount" },
      headerHeight: 150,
      flex: 1,
      minWidth: 200,

      sortable: true,
      unSortIcon: true,

      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: amountCellRenderer("acceptedForDistribution"),
      field: "acceptedForDistribution",
      type: "acceptedForDistributionType",
      headerName: t("pages.configuration.scheme.previewColumns.column7", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Resolved Amount" },
      headerHeight: 150,
      flex: 1,
      minWidth: 200,

      sortable: true,
      unSortIcon: true,

      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
  ];
};
